export default __webpack_public_path__ + "static/box-shadow-db6ee0a27db747aa898a97f8fa148272.png";